import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { map } from 'rxjs/operators';
import { User } from '../_models';
import { Configuration } from '../configuration/configurations';

@Injectable()
export class AuthenticationService {
    baseurl: string = "";
    baseurltoken: string = "";
    constructor(private http: HttpClient,
        private _configurations: Configuration) {
             
    }

   
    login(username: string, password: string) {
        let Body = 'grant_type=password' + '&' + 'username=' + username + '&' + 'password=' + password;

        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
        };
        return this.http.post<any>(this._configurations.baseUrlToken + `/token`, Body, httpOptions);
        
    }
    
    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }

    forgotpassword(username: string,dnsname:string) {
        return this.http.get<User>(this._configurations.baseUrlToken + '/api/User/forgotpassword/' + username + "/"+dnsname+"/")
            .pipe(map(data => {
                console.log("data",data)
                return data;
            }));
        //return this.http.get<User>(this.baseurl + '/api/User/forgotpassword/' + username + "/");
    }
    //get user detail by name
    GetUserDetailByUserName(userName:string) {
        return this.http.get<User>(this._configurations.baseUrlToken + '/api/User/userexists/'+userName+"/");
    }
    GetUserDetailByUserKey(userName:string){
        return this.http.get<User>(this._configurations.baseUrlToken + '/api/User/UserDetailByKey?userName='+userName);
    }
}